import { useEffect } from 'react';
import { useStore } from '@/store/useStore';

/** Session history: list, reload, delete saved sessions (PSD §8.2 / TODO Task 3.13). */
export function SessionHistory(): JSX.Element {
  const sessions = useStore((s) => s.sessions);
  const refreshSessions = useStore((s) => s.refreshSessions);
  const loadSession = useStore((s) => s.loadSession);

  useEffect(() => {
    refreshSessions();
  }, [refreshSessions]);

  if (sessions.length === 0) {
    return (
      <section className="panel panel-result" aria-label="Session history" data-testid="session-history">
        <h2 className="panel-title">Session History</h2>
        <div className="empty-state">No saved sessions yet. Sessions save automatically as you work.</div>
      </section>
    );
  }

  return (
    <section className="panel panel-result" aria-label="Session history" data-testid="session-history">
      <h2 className="panel-title">Session History ({sessions.length})</h2>
      <div className="table-scroll">
        <table className="data-table">
          <thead>
            <tr>
              <th>Patient ID</th>
              <th>Created</th>
              <th>Updated</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {sessions.map((sess) => (
              <tr key={sess.id}>
                <td>{sess.patientId}</td>
                <td>{new Date(sess.createdAtISO).toLocaleString()}</td>
                <td>{new Date(sess.updatedAtISO).toLocaleString()}</td>
                <td>
                  <button className="btn btn-secondary btn-sm" onClick={() => loadSession(sess.id)}>
                    Load
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
